import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-military-calisthenics',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-military-calisthenics-f', 'age-military-calisthenics-f'],
		route: {
			path: '/military-calisthenics-f',
			name: 'female-military-calisthenics-funnel',
		},
	},
	funnel: {
		id: 'ob-female-military-calisthenics',
		route: {
			path: '/military-calisthenics-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-military-calisthenics-onboarding',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'female-military-calisthenics',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-military-calisthenics-f',
	},
	upsell: {
		routeNames: ['upsell-military-calisthenics-f'],
	},
}

export default appAreaConfig
